import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const quickLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Find Jobs", to: "/careers/openings" },
  { label: "Contact", to: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="grid w-fit grid-cols-[auto_auto] items-center gap-x-3.5">
              <img src="/genspire-g-mark.png" alt="Genspire logo" className="h-[31px] w-auto" data-testid="footer-logo" />
              <span className="font-wordmark font-bold text-[26px] text-white tracking-tight leading-none">Genspire</span>
              <span className="col-start-2 mt-[6px] -mr-[0.112em] font-mono text-[9px] uppercase tracking-[0.112em] text-brand-red leading-none" data-testid="footer-tagline">Partner in Progress</span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-white/60 max-w-sm">
              Professional staffing and recruitment solutions that help businesses find the right talent, build stronger teams, and grow with confidence.
            </p>
            <div className="mt-7 flex flex-col items-start gap-4">
              <Link to="/discuss-your-requirement" data-testid="footer-start-conversation"
                className="inline-flex items-center gap-2 text-sm font-medium text-brand-red hover:text-white transition-colors">
                Start a Conversation
                <ArrowRight size={15} />
              </Link>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono text-[11px] uppercase tracking-[0.28em] text-white/40 mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-white/70 hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-mono text-[11px] uppercase tracking-[0.28em] text-white/40 mb-5">Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services/permanent-recruitment" data-testid="footer-link-permanent" className="text-sm text-white/70 hover:text-white transition-colors">Permanent Recruitment</Link></li>
              <li><Link to="/services/contract-staffing" data-testid="footer-link-contract" className="text-sm text-white/70 hover:text-white transition-colors">Contract Staffing</Link></li>
              <li><Link to="/services/rpo" data-testid="footer-link-rpo" className="text-sm text-white/70 hover:text-white transition-colors">Recruitment Process Outsourcing</Link></li>
              <li><Link to="/services/payroll-management" data-testid="footer-link-payroll" className="text-sm text-white/70 hover:text-white transition-colors">Payroll Management</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-mono text-[11px] uppercase tracking-[0.28em] text-white/40 mb-5">Legal</h4>
            <ul className="space-y-3">
              <li><Link to="/privacy" data-testid="footer-link-privacy" className="text-sm text-white/70 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" data-testid="footer-link-terms" className="text-sm text-white/70 hover:text-white transition-colors">Terms & Conditions</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} Genspire. All rights reserved.</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/30">Partner in Progress</p>
        </div>
      </div>
    </footer>
  );
}
